/* La Maison des Aspirateurs — interactions premium (aucune dépendance) */
(function () {
  'use strict';

  /* ---------- Révélation au scroll ---------- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.lmda-reveal:not([data-revealed])');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); el.setAttribute('data-revealed', '1'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { el.setAttribute('data-revealed', '1'); io.observe(el); });
  }

  /* ---------- Accordéons ---------- */
  function initAcc(root) {
    (root || document).querySelectorAll('.lmda-acc__head:not([data-bound])').forEach(function (btn) {
      btn.setAttribute('data-bound', '1');
      btn.addEventListener('click', function () {
        var item = btn.closest('.lmda-acc__item');
        var body = item.querySelector('.lmda-acc__body');
        var open = item.classList.contains('is-open');
        if (open) {
          body.style.height = body.scrollHeight + 'px';
          requestAnimationFrame(function () { body.style.height = '0px'; });
          item.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
        } else {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          body.style.height = body.scrollHeight + 'px';
          body.addEventListener('transitionend', function te() {
            if (item.classList.contains('is-open')) body.style.height = 'auto';
            body.removeEventListener('transitionend', te);
          });
        }
      });
    });
  }

  /* ---------- Galerie ---------- */
  function initGallery(root) {
    (root || document).querySelectorAll('.lmda-gal:not([data-bound])').forEach(function (gal) {
      gal.setAttribute('data-bound', '1');
      var slides = gal.querySelectorAll('.lmda-gal__slide');
      var thumbs = gal.querySelectorAll('.lmda-gal__thumb');
      if (slides.length < 1) return;
      var i = 0;
      function go(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
        var t = thumbs[i];
        if (t && t.parentNode) t.parentNode.scrollTo({ left: t.offsetLeft - 60, behavior: 'smooth' });
      }
      gal.querySelectorAll('[data-gal-prev]').forEach(function (b) { b.addEventListener('click', function () { go(i - 1); }); });
      gal.querySelectorAll('[data-gal-next]').forEach(function (b) { b.addEventListener('click', function () { go(i + 1); }); });
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
      gal.addEventListener('lmda:showMedia', function (e) {
        var id = String(e.detail || '');
        slides.forEach(function (s, k) { if (s.getAttribute('data-media-id') === id) go(k); });
      });
      /* glissement tactile */
      var x0 = null;
      gal.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      gal.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 45) go(dx < 0 ? i + 1 : i - 1);
        x0 = null;
      }, { passive: true });
      go(0);
    });
  }

  /* ---------- Carrousel d'avis ---------- */
  function initQuotes(root) {
    (root || document).querySelectorAll('.lmda-quote:not([data-bound])').forEach(function (q) {
      q.setAttribute('data-bound', '1');
      var items = q.querySelectorAll('.lmda-quote__item');
      var dots = q.querySelectorAll('.lmda-quote__dot');
      if (items.length < 2) return;
      var i = 0, timer;
      function go(n) {
        i = (n + items.length) % items.length;
        items.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      }
      function play() { clearInterval(timer); timer = setInterval(function () { go(i + 1); }, 6000); }
      dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); play(); }); });
      q.addEventListener('mouseenter', function () { clearInterval(timer); });
      q.addEventListener('mouseleave', play);
      go(0); play();
    });
  }

  /* ---------- Sélecteur de variante ---------- */
  function initVariants(root) {
    (root || document).querySelectorAll('[data-lmda-product]:not([data-bound])').forEach(function (form) {
      form.setAttribute('data-bound', '1');
      var dataEl = form.querySelector('[data-lmda-variants]');
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var idInput = form.querySelector('[name="id"]');
      var priceNow = form.querySelector('[data-lmda-price-now]');
      var priceWas = form.querySelector('[data-lmda-price-was]');
      var stockEl = form.querySelector('[data-lmda-stock]');
      var cta = form.querySelector('[data-lmda-cta]');
      var stickyCta = document.querySelector('[data-lmda-sticky-cta]');
      var stickyPrice = document.querySelector('[data-lmda-sticky-price]');
      var money = form.getAttribute('data-money-format') || '{{amount_with_comma_separator}} €';

      function fmt(cents) {
        var v = (cents / 100).toFixed(2).replace('.', ',');
        var parts = v.split(',');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        return parts.join(',') + ' €';
      }
      function selected() {
        return Array.prototype.map.call(form.querySelectorAll('[data-lmda-opt]'), function (grp) {
          var b = grp.querySelector('.lmda-opt__btn.is-active');
          return b ? b.getAttribute('data-value') : null;
        });
      }
      function match(sel) {
        return variants.filter(function (v) {
          return sel.every(function (s, k) { return s === null || v.options[k] === s; });
        })[0];
      }
      function paint() {
        var sel = selected();
        var v = match(sel);
        /* options indisponibles */
        form.querySelectorAll('[data-lmda-opt]').forEach(function (grp, gi) {
          grp.querySelectorAll('.lmda-opt__btn').forEach(function (b) {
            var test = sel.slice();
            test[gi] = b.getAttribute('data-value');
            var cand = variants.filter(function (vv) {
              return test.every(function (s, k) { return s === null || vv.options[k] === s; });
            });
            var any = cand.some(function (vv) { return vv.available; });
            b.classList.toggle('is-off', cand.length > 0 && !any);
          });
        });
        if (!v) { if (cta) { cta.disabled = true; cta.textContent = 'Combinaison indisponible'; } return; }
        if (idInput) idInput.value = v.id;
        if (priceNow) priceNow.textContent = fmt(v.price);
        if (priceWas) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            priceWas.textContent = fmt(v.compare_at_price); priceWas.hidden = false;
          } else { priceWas.hidden = true; }
        }
        if (stockEl) {
          stockEl.classList.toggle('lmda-stock--out', !v.available);
          stockEl.querySelector('[data-lmda-stock-txt]').textContent =
            v.available ? 'En stock — expédié sous 24 à 48 h' : 'Temporairement indisponible';
        }
        if (cta) { cta.disabled = !v.available; cta.textContent = v.available ? 'Ajouter au panier' : 'Rupture de stock'; }
        if (stickyCta) stickyCta.disabled = !v.available;
        if (stickyPrice) stickyPrice.textContent = fmt(v.price);
        if (v.featured_media_id) {
          var gal = document.querySelector('.lmda-gal');
          if (gal) gal.dispatchEvent(new CustomEvent('lmda:showMedia', { detail: v.featured_media_id }));
        }
        if (window.history && window.history.replaceState) {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', u.toString());
        }
      }
      form.querySelectorAll('.lmda-opt__btn').forEach(function (b) {
        b.addEventListener('click', function () {
          if (b.classList.contains('is-off')) return;
          b.closest('[data-lmda-opt]').querySelectorAll('.lmda-opt__btn')
            .forEach(function (o) { o.classList.remove('is-active'); });
          b.classList.add('is-active');
          paint();
        });
      });
      /* quantité */
      var qty = form.querySelector('[data-lmda-qty]');
      if (qty) {
        form.querySelectorAll('[data-lmda-qty-step]').forEach(function (b) {
          b.addEventListener('click', function () {
            var d = parseInt(b.getAttribute('data-lmda-qty-step'), 10);
            qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + d);
          });
        });
      }
      /* barre collante : renvoie sur le formulaire principal */
      if (stickyCta) {
        stickyCta.addEventListener('click', function () {
          if (cta && !cta.disabled) cta.click();
        });
      }
      paint();
    });
  }

  /* ---------- Barre collante ---------- */
  function initSticky() {
    var bar = document.querySelector('.lmda-sticky');
    var anchor = document.querySelector('[data-lmda-cta]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { bar.classList.toggle('is-in', !e.isIntersecting && e.boundingClientRect.top < 0); });
    }, { threshold: 0 }).observe(anchor);
  }


  /* ---------- Bandeau d'avis : lit le widget Judge.me et le reformate ---------- */
  function stars(n) {
    var full = Math.round(n), out = '';
    for (var i = 1; i <= 5; i++) out += (i <= full ? '★' : '☆');
    return out;
  }
  function shortName(raw) {
    var t = String(raw || '').replace(/\s+/g, ' ').trim();
    if (!t) return 'Client vérifié';
    var p = t.split(' ');
    if (p.length === 1) return p[0];
    return p[0] + ' ' + p[p.length - 1].charAt(0).toUpperCase() + '.';
  }
  function readJudgeme() {
    var src = document.querySelector('.lmda-revs__src');
    if (!src) return null;
    var nodes = src.querySelectorAll('.jdgm-rev');
    if (!nodes.length) return null;
    var list = [];
    Array.prototype.forEach.call(nodes, function (n) {
      var body = n.querySelector('.jdgm-rev__body');
      var author = n.querySelector('.jdgm-rev__author');
      var rateEl = n.querySelector('.jdgm-rev__rating');
      var rating = rateEl ? parseFloat(rateEl.getAttribute('data-score')) : 5;
      var txt = body ? (body.textContent || '').replace(/\s+/g, ' ').trim() : '';
      if (!txt || txt.length < 12) return;                 /* on écarte les avis vides */
      list.push({ t: txt, a: shortName(author && author.textContent), r: isNaN(rating) ? 5 : rating });
    });
    if (!list.length) return null;
    var avgEl = src.querySelector('.jdgm-rev-widg__summary-average');
    var cntEl = src.querySelector('.jdgm-rev-widg__summary-text');
    var avg = avgEl ? parseFloat((avgEl.textContent || '').replace(',', '.')) : null;
    var cnt = cntEl ? (String(cntEl.textContent).match(/\d[\d\s]*/) || [''])[0].trim() : '';
    if (!avg || isNaN(avg)) {
      avg = list.reduce(function (a, b) { return a + b.r; }, 0) / list.length;
    }
    return { avg: avg, count: cnt || String(list.length), items: list };
  }
  function paintCarousel(wrap, items, prefix, trackSel, dotsSel, dotCls) {
    /* prefix : 'lmda-inrevs' ou 'lmda-revs' — les classes suivent le meme schema BEM */
    var track = wrap.querySelector(trackSel);
    var dots  = wrap.querySelector(dotsSel);
    var cardCls = prefix + '__card';
    track.innerHTML = items.map(function () {
      return '<article class="' + cardCls + '">' +
        '<div class="lmda-stars" data-rv-stars></div>' +
        '<p class="' + prefix + '__body" data-rv-body></p>' +
        '<div class="' + prefix + '__who"><span data-rv-who></span>' +
        '<span class="lmda-revs__ok"><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>Vérifié</span>' +
        '</div></article>';
    }).join('');
    var cards = track.querySelectorAll('.' + cardCls);
    items.forEach(function (it, k) {
      if (!cards[k]) return;
      cards[k].querySelector('[data-rv-stars]').textContent = stars(it.r);
      cards[k].querySelector('[data-rv-body]').textContent = '« ' + it.t + ' »';
      cards[k].querySelector('[data-rv-who]').textContent = it.a;
    });

    function perView() {
      if (prefix.indexOf('inrevs') > -1) return 1;
      var w = window.innerWidth;
      return w >= 1100 ? 3 : (w >= 750 ? 2 : 1);
    }
    var pages = 1, i = 0, timer;
    function renderDots() {
      pages = Math.max(1, Math.ceil(items.length / perView()));
      dots.innerHTML = '';
      for (var d = 0; d < pages; d++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = dotCls + (d === 0 ? ' is-active' : '');
        b.setAttribute('aria-label', 'Avis ' + (d + 1));
        (function (idx) { b.addEventListener('click', function () { go(idx); play(); }); })(d);
        dots.appendChild(b);
      }
    }
    function go(n) {
      i = (n + pages) % pages;
      track.style.transform = 'translateX(-' + (i * 100) + '%)';
      Array.prototype.forEach.call(dots.children, function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    function play() { clearInterval(timer); if (pages > 1) timer = setInterval(function () { go(i + 1); }, 5500); }
    renderDots(); go(0); play();
    wrap.addEventListener('mouseenter', function () { clearInterval(timer); });
    wrap.addEventListener('mouseleave', play);
    window.addEventListener('resize', function () { renderDots(); go(0); });
  }

  function bindDisclosure() {
    var note = document.querySelector('[data-revs-note]');
    if (!note) return;
    document.querySelectorAll('[data-revs-info]').forEach(function (b) {
      if (b.getAttribute('data-bound')) return;
      b.setAttribute('data-bound', '1');
      b.addEventListener('click', function () { note.hidden = !note.hidden; });
    });
  }

  function buildReviews() {
    var hero   = document.querySelector('[data-lmda-hero-rating]');
    var inline = document.querySelector('[data-lmda-inline-reviews]');
    var band   = document.querySelector('[data-lmda-reviews]');
    if (!hero && !inline && !band) return true;
    if (document.body.getAttribute('data-lmda-revs-built')) return true;

    var data = readJudgeme();
    if (!data) return false;
    document.body.setAttribute('data-lmda-revs-built', '1');

    /* note au-dessus du titre */
    if (hero) {
      hero.querySelector('[data-hero-stars]').textContent = stars(data.avg);
      hero.querySelector('[data-hero-avg]').textContent = data.avg.toFixed(1).replace('.', ',');
      hero.querySelector('[data-hero-count]').textContent = '· ' + data.count + ' avis';
      hero.hidden = false;
    }

    /* carrousel dans la colonne d'achat */
    if (inline) {
      var maxI = parseInt(inline.getAttribute('data-max'), 10) || 8;
      paintCarousel(inline, data.items.slice(0, maxI), 'lmda-inrevs',
                    '[data-inrevs-track]', '[data-inrevs-dots]', 'lmda-inrevs__dot');
      inline.hidden = false;
    }

    /* bandeau autonome, s'il est présent dans le gabarit */
    if (band) {
      var maxB = parseInt(band.getAttribute('data-max'), 10) || 8;
      band.querySelector('[data-revs-avg]').textContent = data.avg.toFixed(1).replace('.', ',');
      band.querySelector('[data-revs-stars]').textContent = stars(data.avg);
      band.querySelector('[data-revs-count]').textContent = data.count + ' avis';
      paintCarousel(band, data.items.slice(0, maxB), 'lmda-revs',
                    '[data-revs-track]', '[data-revs-dots]', 'lmda-revs__dot');
      band.hidden = false;
      initReveal(band);
    }

    bindDisclosure();
    return true;
  }

  function watchReviews() {
    if (!document.querySelector('[data-lmda-reviews], [data-lmda-hero-rating], [data-lmda-inline-reviews]')) return;
    if (buildReviews()) return;
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (buildReviews() || tries > 40) clearInterval(iv);   /* ~20 s max */
    }, 500);
  }


  /* ---------- Titre : ajusté pour tenir sur une seule ligne ---------- */
  function fitTitle(root) {
    var els = (root || document).querySelectorAll('.lmda-h1:not([data-fitted])');
    if (!els.length) return;
    Array.prototype.forEach.call(els, function (el) {
      el.setAttribute('data-fitted', '1');
      var MAX = 34, MIN = 22, STEP = 0.5;
      function fit() {
        /* on mesure en une seule ligne, puis on ne garde nowrap que si ça tient */
        el.classList.add('is-oneline');
        var size = MAX, guard = 0;
        el.style.fontSize = size + 'px';
        while (el.scrollWidth > el.clientWidth + 1 && size > MIN && guard < 60) {
          size -= STEP;
          el.style.fontSize = size + 'px';
          guard++;
        }
        if (el.scrollWidth > el.clientWidth + 1) {
          /* trop long même au minimum : on repasse sur deux lignes, jamais de texte coupé */
          el.classList.remove('is-oneline');
          el.style.fontSize = MIN + 'px';
        }
      }
      fit();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit).catch(function () {});
      var t;
      window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(fit, 150); });
    });
  }

  function boot(root) {
    initReveal(root); initAcc(root); initGallery(root); fitTitle(root);
    initQuotes(root); initVariants(root); initSticky(); watchReviews();
  }

  window.__lmdaBoot = boot;
  document.addEventListener('lmda:rescan', function () { boot(document); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else { boot(document); }

  /* éditeur de thème Shopify */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:select', function (e) { boot(e.target); });
})();
(function(){if(window.__lmdaRv||!/\/products\//.test(location.pathname))return;window.__lmdaRv=1;var SHOP='dns2fg-sw.myshopify.com';var NOTE='Ces avis ont été laissés par des acheteurs de ce modèle sur une autre plateforme de vente. Ils ont été traduits automatiquement en français et ne sont pas vérifiés par La Maison des Aspirateurs. Les avis de nos propres clients porteront la mention « Achat vérifié ».';var FRW=' le la les très est et bien produit aspirateur je il elle pas pour avec bon bonne merci parfait qualité conforme reçu livraison super fonctionne rapide un une des du de que qui mais plus trop ce cette c\'est j\'ai comme sur dans au mon ma vous nous tout facile puissant petit prix excellent recommande satisfait vraiment ne en a à ';function isFr(t){var w=(t||'').toLowerCase().split(/[^a-zàâçéèêëîïôûùüÿœąćęłńóśźż'а-яё]+/).filter(Boolean);if(!w.length)return true;if(/[ąćęłńśźżа-яё]/i.test(t))return false;var f=0;for(var i=0;i<w.length;i++){if(FRW.indexOf(' '+w[i]+' ')>-1)f++;}return f/w.length>=0.15||(w.length<4&&f>0);}function pid(){try{if(window.ShopifyAnalytics&&ShopifyAnalytics.meta&&ShopifyAnalytics.meta.product)return ShopifyAnalytics.meta.product.id;}catch(e){}var i=document.querySelector('input[name="product-id"]');return i?i.value:null;}function stars(r){var p=Math.max(0,Math.min(100,r/5*100));return '<span class="lmda-st" aria-hidden="true"><span class="lmda-st__bg">★★★★★</span><span class="lmda-st__fg" style="width:'+p+'%">★★★★★</span></span>';}function esc(s){var d=document.createElement('div');d.textContent=s||'';return d.innerHTML;}function txt(h){var d=document.createElement('div');d.innerHTML=(h||'').replace(/<br\s*\/?>/gi,' ');return (d.textContent||'').replace(/\s+/g,' ').trim();}function sname(n){n=txt(n);var p=n.split(' ');return p.length>1?p[0]+' '+p[p.length-1].charAt(0)+'.':n;}function info(id){return '<button type="button" class="lmda-rv-i" aria-expanded="false" aria-controls="'+id+'">Avis non vérifiés · traduits <span aria-hidden="true">ⓘ</span></button>';}function bind(root){root.querySelectorAll('.lmda-rv-i').forEach(function(b){b.addEventListener('click',function(){var n=document.getElementById(b.getAttribute('aria-controls'));if(!n)return;var o=n.hasAttribute('hidden');if(o)n.removeAttribute('hidden');else n.setAttribute('hidden','');b.setAttribute('aria-expanded',o?'true':'false');});});}function widget(){return document.querySelector('.jdgm-horizon-widget');}function markW(note){var k=0;(function go(){var w=widget();if(w){w.classList.add('lmda-ok');if(!w.id)w.id='lmda-avis';if(note&&!w.querySelector('.lmda-rv-wnote')){var m=document.createElement('div');m.className='lmda-rv-wnote';m.innerHTML=info('lmda-rv-n3')+'<p id="lmda-rv-n3" class="lmda-rv-note" hidden>'+NOTE+'</p>';w.insertBefore(m,w.firstChild);bind(m);}return;}if(k++<30)setTimeout(go,500);})();}function run(){var id=pid();if(!id)return;fetch('https://cdn.judge.me/reviews/reviews_for_widget?product_id='+id+'&page=1&per_page=40&sort_by=rating&sort_dir=desc&shop_domain='+SHOP+'&platform=shopify').then(function(r){return r.ok?r.json():null;}).then(function(j){if(!j)return;var n=j.number_of_reviews||0,revs=j.reviews||[];if(!n){markW(false);return;}var fr=revs.filter(function(r){return isFr(txt(r.body_html));}).length/Math.max(1,revs.length);if(fr<0.8)return;var avg=parseFloat(j.average_rating)||0,at=avg.toFixed(1).replace('.',',');markW(true);var h1=document.querySelector('.lmda-product h1.lmda-h1')||document.querySelector('.lmda-product h1');if(h1&&!document.querySelector('.lmda-rv-sum')){var s=document.createElement('div');s.className='lmda-rv-sum';s.innerHTML='<a href="#lmda-avis" class="lmda-rv-sum__link">'+stars(avg)+'<span class="lmda-rv-sum__avg">'+at+'/5</span><span class="lmda-rv-sum__n">('+n+' avis)</span></a>'+info('lmda-rv-n1')+'<p id="lmda-rv-n1" class="lmda-rv-note" hidden>'+NOTE+'</p>';h1.parentNode.insertBefore(s,h1);bind(s);s.querySelector('a').addEventListener('click',function(e){var t=widget();if(t){e.preventDefault();t.scrollIntoView({behavior:'smooth',block:'start'});}});}var picks=revs.map(function(r){return {r:r.rating,b:txt(r.body_html),n:sname(r.reviewer_name),i:(r.reviewer_initial||'').toUpperCase(),ph:(r.pictures_urls||[]).map(function(p){return typeof p==='string'?p:(p.compact||p.small||p.original);}).filter(Boolean)};}).filter(function(x){return x.r>=4&&x.b.length>=25&&x.b.length<=280&&isFr(x.b);}).sort(function(a,b){return (b.ph.length?1:0)-(a.ph.length?1:0);}).slice(0,8);var an=document.querySelector('.lmda-product .lmda-pay')||document.querySelector('.lmda-product .lmda-buy');if(an&&picks.length&&!document.querySelector('.lmda-rv')){var c=document.createElement('div');c.className='lmda-rv';var cards=picks.map(function(x){return '<figure class="lmda-rv__card"><div class="lmda-rv__top"><span class="lmda-rv__av" aria-hidden="true">'+esc(x.i||x.n.charAt(0))+'</span><span class="lmda-rv__who"><span class="lmda-rv__name">'+esc(x.n)+'</span>'+stars(x.r)+'</span>'+(x.ph[0]?'<img class="lmda-rv__ph" src="'+esc(x.ph[0])+'" alt="" loading="lazy" width="44" height="44">':'')+'</div><blockquote class="lmda-rv__txt">« '+esc(x.b)+' »</blockquote></figure>';}).join('');c.innerHTML='<div class="lmda-rv__head"><p class="lmda-rv__title">Ils en parlent</p>'+info('lmda-rv-n2')+'</div><p id="lmda-rv-n2" class="lmda-rv-note" hidden>'+NOTE+'</p><div class="lmda-rv__wrap"><button type="button" class="lmda-rv__nav lmda-rv__nav--prev" aria-label="Avis précédent">‹</button><div class="lmda-rv__track">'+cards+'</div><button type="button" class="lmda-rv__nav lmda-rv__nav--next" aria-label="Avis suivant">›</button></div><div class="lmda-rv__dots" aria-hidden="true">'+picks.map(function(_,k){return '<span'+(k?'':' class="is-on"')+'></span>';}).join('')+'</div>';an.parentNode.insertBefore(c,an.nextSibling);bind(c);var tr=c.querySelector('.lmda-rv__track'),dots=c.querySelectorAll('.lmda-rv__dots span');function cw(){return tr.querySelector('.lmda-rv__card').getBoundingClientRect().width+12;}c.querySelector('.lmda-rv__nav--prev').addEventListener('click',function(){tr.scrollBy({left:-cw(),behavior:'smooth'});});c.querySelector('.lmda-rv__nav--next').addEventListener('click',function(){tr.scrollBy({left:cw(),behavior:'smooth'});});tr.addEventListener('scroll',function(){var k=Math.round(tr.scrollLeft/cw());dots.forEach(function(d,m){d.classList.toggle('is-on',m===k);});},{passive:true});}}).catch(function(){});}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();})();
(function(){if(!/\/products\//.test(location.pathname))return;var k=0;(function go(){var w=document.querySelector('.jdgm-horizon-widget.lmda-ok'),c=document.querySelector('.lmda-rv');if(w&&c){if(!c.querySelector('.lmda-rv-all')){var d=document.createElement('details');d.className='lmda-rv-all';var s=document.createElement('summary');var n=document.querySelector('.lmda-rv-sum__n');var nb=n?n.textContent.replace(/\D/g,''):'';s.textContent=nb?'Voir les '+nb+' avis':'Voir tous les avis';d.appendChild(s);var sec=w.closest('.shopify-section');d.appendChild(w);c.appendChild(d);if(sec)sec.style.display='none';var a=document.querySelector('.lmda-rv-sum__link');if(a)a.addEventListener('click',function(e){e.preventDefault();e.stopImmediatePropagation();d.open=true;c.scrollIntoView({behavior:'smooth',block:'start'});},true);}return;}if(k++<40)setTimeout(go,500);})();})();!function(){var e=document;window;function t(t,n){return(n||e).querySelector(t)}function n(t,n){return Array.prototype.slice.call((n||e).querySelectorAll(t))}function a(t){!function(t,n,a){for(var r,o=e.createTreeWalker(t,NodeFilter.SHOW_TEXT,null),i=[];r=o.nextNode();)n.test(r.nodeValue)&&i.push(r);i.forEach(a)}(t||e.body,/TVA incluse\.?|Droits de douane et taxes inclus\.?|Page not found|The link may be incorrect|Continue shopping|Discover something new|calculée lors du paiement/,function(e){e.nodeValue=e.nodeValue.replace(/TVA incluse\.?/,"TVA non applicable, art. 293 B du CGI").replace(/Droits de douane et taxes inclus\.?/,"TVA non applicable, art. 293 B du CGI.").replace("Page not found","Page introuvable").replace(/The link may be incorrect, or the page has been removed\.?/,"Le lien est peut-être incorrect ou la page n’existe plus.").replace("Continue shopping","Continuer mes achats").replace("Discover something new","Découvrez nos modèles").replace(/L[’']expédition est calculée lors du paiement\.?/,"Livraison offerte en France.")})}function r(t){n("dt,dd,span,p,div,li",t||e).forEach(function(e){if(!e.childElementCount){var t=(e.textContent||"").trim();if(/^Exp[ée]dition\s*:?$/.test(t)&&(/^\/cart/.test(location.pathname)||e.closest('cart-drawer,cart-items-component,[class*="cart"],[id*="cart"],[id*="Cart"]'))){var n=e.parentElement;if(n&&n.children.length<=3&&(n.textContent||"").length<60)n.style.display="none";else{e.style.display="none";var a=e.nextElementSibling;a&&(a.style.display="none")}}}})}function o(){if(/\/products\//.test(location.pathname)){var a=t(".lmda-product");if(a){var r=n("*",a).filter(function(e){return!e.childElementCount&&/^\s*\d[\d\s]*,\d{2}\s*€\s*$/.test(e.textContent)})[0];if(r){var o=parseFloat(r.textContent.replace(/[^\d,]/g,"").replace(",","."));if(!(!o||o<35||o>1500)){var i=(Math.ceil(o/3*100)/100).toFixed(2).replace(".",","),l=t(".lmda-bnpl");if(!l){(l=e.createElement("p")).className="lmda-bnpl",l.style.cssText="margin:6px 0 0;font-size:13.5px;color:#2c2011;opacity:.85";var s=r.parentElement;s.parentNode.insertBefore(l,s.nextSibling)}var c="ou 3 × "+i+" € sans frais avec Klarna (sous réserve d’acceptation)";l.textContent!==c&&(l.textContent=c)}}}}}var i=/koursk|kursk|moscou|russie|russia|ukrain|kiev|kyiv|varsovie|polska|arabie|saoudi|riyad|dubai|israel|chili|br[ée]sil|mexique|aliexpress|vendeur|magasin|abir|ilife|redkey|lefant|laresar|tineco|xiaomi|dyson|erabros|prettycare|\bx\d\b|pas encore (test|essay|utilis)|reviendrai|cadeau pour|yandex/i;function l(){var e=t(".lmda-rv");if(!e||e.getAttribute("data-clean"))return!1;var a=n(".lmda-rv__card",e);a.forEach(function(e){i.test(e.textContent)&&e.parentNode.removeChild(e)});var r=n(".lmda-rv__card",e).length;if(r)for(var o=n(".lmda-rv__dots span",e),l=r;l<o.length;l++)o[l].parentNode.removeChild(o[l]);else e.style.display="none";return e.setAttribute("data-clean","1"),!0}function s(){try{a(),r(),n("h2,h3,p").forEach(function(e){if(/Compl[ée]tez votre [ée]quipement/i.test(e.textContent)){var t=e.closest(".shopify-section");t&&(t.style.display="none")}}),o(),function(){if("/"===location.pathname&&!t(".lmda-hero-cta")){var a=t('[id*="media_with_content"]');if(a){var r=t("h1,h2,.h1,.h2",a)||n("*",a).filter(function(e){return/Sublimez votre/.test(e.textContent)&&!e.childElementCount})[0];if(r){var o=n('a[href*="/collections/"]'),i=e.createElement("div");i.className="lmda-hero-cta",i.style.cssText="margin-top:22px;display:flex;flex-wrap:wrap;gap:10px;align-items:center";var l="display:inline-block;padding:14px 22px;border-radius:999px;font-weight:600;font-size:15px;text-decoration:none;";i.innerHTML='<p style="flex-basis:100%;margin:0 0 6px;font-size:16px;line-height:1.5;color:#2c2011;opacity:.85">Aspirateurs robots, balais sans fil et laveurs sélectionnés pour la maison.</p><a href="'+s(/Robots?/i,"/collections/all")+'" style="'+l+'background:#2c2011;color:#fff">Trouver mon robot</a><a href="'+s(/Balai/i,"/collections/all")+'" style="'+l+'border:1px solid #2c2011;color:#2c2011">Voir les balais</a><p style="flex-basis:100%;margin:8px 0 0;font-size:13px;color:#2c2011;opacity:.7">Livraison offerte · 14 jours pour changer d’avis · Garantie 2 ans</p>',r.parentNode.insertBefore(i,r.nextSibling)}}}function s(e,t){var n=o.filter(function(t){return e.test(t.textContent)})[0];return n?n.getAttribute("href"):t}}(),l(),n("a[href]").forEach(function(e){var t=e.getAttribute("href");/^(https?:\/\/[^\/]+)?\/collections\/all\/?$/.test(t)&&e.setAttribute("href",t.replace(/\/?$/,"")+"?sort_by=price-descending")})}catch(e){}}"loading"===e.readyState?e.addEventListener("DOMContentLoaded",s):s();var c=0,d=setInterval(function(){s(),++c>30&&clearInterval(d)},500);try{new MutationObserver(function(e){e.forEach(function(e){e.addedNodes&&Array.prototype.forEach.call(e.addedNodes,function(e){1===e.nodeType&&(a(e),r(e))})}),o(),l()}).observe(e.body,{childList:!0,subtree:!0})}catch(e){}}();